// AccessRecruitPageStyles.js
export const styles = {
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    // background: 'linear-gradient(135deg, #d32f2f 0%, #212121 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  },
  loadingContent: {
    background: 'white',
    padding: '40px',
    borderRadius: '16px',
    textAlign: 'center',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
    maxWidth: '300px',
    width: '90%'
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #ea6666',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    margin: '0 auto 20px'
  },
  trialEndedContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    // background: 'linear-gradient(135deg, #d32f2f 0%, #212121 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  },
  trialEndedContent: {
    background: 'white',
    padding: '40px',
    borderRadius: '16px',
    textAlign: 'center',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
    maxWidth: '400px',
    width: '90%'
  },
  trialEndedIcon: {
    fontSize: '4rem',
    marginBottom: '20px'
  },
  trialEndedTitle: {
    color: '#d63031',
    marginBottom: '16px',
    fontSize: '1.8rem'
  },
  trialEndedMessage: {
    color: '#666',
    marginBottom: '30px',
    fontSize: '1.1rem',
    lineHeight: '1.5'
  },
  upgradeButton: {
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    color: 'white',
    border: 'none',
    padding: '16px 32px',
    borderRadius: '8px',
    fontSize: '1.1rem',
    fontWeight: '600',
    cursor: 'pointer',
    marginBottom: '15px',
    width: '100%',
    transition: 'all 0.3s ease'
  },
  backButton: {
    background: 'transparent',
    color: '#ea6666',
    border: '2px solid #ea6666',
    padding: '12px 24px',
    borderRadius: '8px',
    fontSize: '1rem',
    fontWeight: '500',
    cursor: 'pointer',
    width: '100%',
    transition: 'all 0.3s ease'
  }
};